import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Sem este plugin, dayjs ignora o formato "DD/MM/YYYY" e faz parse nativo
// (interpreta como MM/DD), o que dá Invalid Date pra qualquer dia > 12 —
// era a causa do campo esvaziar ao editar/desfocar.
dayjs.extend(customParseFormat);

// Campo de data editável, independente da cor (ao contrário do fluxo
// antigo, editar aqui nunca mexe em revisionStatus.color).
const RevisionDateField = ({ currentDate, onSave, disabled }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(
      currentDate && dayjs(currentDate).isValid()
        ? dayjs(currentDate).format("DD/MM/YYYY")
        : ""
    );
  }, [currentDate]);

  const commit = (raw) => {
    if (raw.length !== 10 && raw.length !== 0) return;
    const formatted = currentDate && dayjs(currentDate).isValid()
      ? dayjs(currentDate).format("DD/MM/YYYY")
      : "";
    if (raw === formatted) return;

    if (raw.length === 10) {
      const parsed = dayjs(raw, "DD/MM/YYYY", true);
      // Data inválida (ex.: 45/13/2026) — não salva nem apaga, restaura
      // o que estava antes.
      if (!parsed.isValid()) {
        setValue(formatted);
        return;
      }
      onSave(parsed.toDate());
    } else {
      onSave(null);
    }
  };

  return (
    <InputMask
      className="revision-date-input"
      mask="99/99/9999"
      maskChar={null}
      placeholder="__/__/____"
      disabled={disabled}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={(e) => commit(e.target.value)}
    />
  );
};

export default RevisionDateField;
